export enum DispatchType {
  Normal = 0,
  HubTransfer = 1,
  Linehaul = 2,
  PAndD = 3,

  Normal53 = 10,
  MT53 = 11,

  NormalPup = 20,
  MTPup = 21
}

export const DispatchTypeMapping: Record<DispatchType, string> = {
  [DispatchType.Normal]: 'Normal Dispatch',
  [DispatchType.HubTransfer]: 'Hub Transfer',
  [DispatchType.Linehaul]: 'Linehaul Dispatch',
  [DispatchType.PAndD]: 'P&D Dispatch',
  [DispatchType.Normal53]: 'Normal 53',
  [DispatchType.MT53]: 'MT 53',
  [DispatchType.NormalPup]: 'Normal Pup',
  [DispatchType.MTPup]: 'MT Pup'
};

export const DispatchTypeArrow: Record<DispatchType, string> = {
  [DispatchType.Normal]: '\u2192',
  [DispatchType.HubTransfer]: '\u21E8',
  [DispatchType.Linehaul]: 'LH>',
  [DispatchType.PAndD]: 'P&D>',
  [DispatchType.Normal53]: '53>',
  [DispatchType.MT53]: 'MT53>',
  [DispatchType.NormalPup]: 'Pup>',
  [DispatchType.MTPup]: 'MTPup>'
};

